<template>
    <!-- card -->
    <v-card
        outlined
        max-width="95%"
        class="visit-card mx-auto"
    >
        <v-card-text>
            <v-row class="justify-space-between align-center">
                <v-col cols="12">
                    <span class="text-capitalize primary--text text--darken-1 text-subtitle-2">
                        {{ getFullMaterialName(getMaterialById(transaction.materialId)) }}
                    </span>
                </v-col>
            </v-row>

            <v-row class="justify-space-between align-center" dense>
                <v-col cols="6">
                    <span class="text-caption grey--text text--darken-1">{{$T('inputs.from')}}:</span>
                    {{ transaction.fromAccountName || '-' }}
                </v-col>
                <v-col cols="6">
                    <span class="text-caption grey--text text--darken-1">{{$T('inputs.quantity')}}:</span>
                    {{ transaction.amount != null ? $options.filters.formatNumber(transaction.amount, 3) : 0 }}
                </v-col>
                <v-col cols="6">
                    <span class="text-caption grey--text text--darken-1">{{$T('inputs.date')}}:</span>
                    {{ formatDate(transaction.date) }}
                </v-col>
                <v-col cols="6" class="text-end">
                    <v-btn
                    color="success"
                    small
                    :loading="accepting"
                    :disabled="accepting"
                    @click="$emit('accept', transaction.id)"
                    >
                        {{$T('Products.accept')}}
                    </v-btn>
                </v-col>
            </v-row>
        </v-card-text>

    </v-card>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'

export default {
	props: {
		transaction: {
			type: Object,
			required: true
		},
		accepting: {
			type: Boolean,
			default: false
		}
	},

	methods: {
		getFullMaterialName(material) {
			const details = [
				this.getMaterialFormById(material?.materialFormId)?.name,
				material?.dose,
				material.strength
			];

			return `${material.name} (${details.filter(c => c != null).join(' ')})`;
		},

		formatDate(value) {
			return value ? moment(value).format('YYYY-MM-DD') : '-';
		}
	},

	computed: {
		...mapGetters({
			getMaterialById: 'materials/getMaterialById',
			getMaterialFormById: 'materialForms/getMaterialFormById',
		})
	},
}
</script>

<style>

</style>
